module.exports = __webpack_public_path__ + "img/sand1.4ef3e248.jpg";